import { useCallback } from 'react';
export const useSubmit = ({ values, validateFields, handleScrollToFirstError, onSubmit, }) => {
    const submitForm = useCallback(async () => {
        const errors = await validateFields();
        if (errors && errors.length) {
            handleScrollToFirstError(errors);
        }
        return onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(values, errors);
    }, [validateFields, onSubmit, values, handleScrollToFirstError]);
    return { submitForm };
};
//# sourceMappingURL=use-submit.js.map